export class MerchantOrder {
  constructor({
    id,
    merchantId,
    merchantName,
    store_id,
    status = 'pending',
    consolidatedOrderId = null,
    items = [],
    total = 0,
    notes = '',
    createdBy,
    createdAt,
    receivedAt = null,
  }) {
    this.id = id;
    this.merchantId = merchantId;
    this.merchantName = merchantName;
    this.store_id = store_id;
    this.status = status;
    this.consolidatedOrderId = consolidatedOrderId;
    this.items = items;
    this.total = total;
    this.notes = notes;
    this.createdBy = createdBy;
    this.createdAt = createdAt;
    this.receivedAt = receivedAt;
  }

  toJson() {
    return {
      merchantId: this.merchantId,
      merchantName: this.merchantName,
      store_id: this.store_id,
      status: this.status,
      consolidatedOrderId: this.consolidatedOrderId,
      items: this.items,
      total: this.total,
      notes: this.notes || '',
      createdBy: this.createdBy,
      createdAt: this.createdAt,
      receivedAt: this.receivedAt,
    };
  }

  static fromFirebase(doc) {
    const data = doc.data();
    return new MerchantOrder({
      id: doc.id,
      merchantId: data.merchantId,
      merchantName: data.merchantName,
      store_id: data.store_id,
      status: data.status || 'pending',
      consolidatedOrderId: data.consolidatedOrderId || null,
      items: data.items || [],
      total: data.total || 0,
      notes: data.notes || '',
      createdBy: data.createdBy,
      createdAt: data.createdAt,
      receivedAt: data.receivedAt || null,
    });
  }

  static calculateTotal(items) {
    return items.reduce((sum, item) => sum + (item.quantity * item.unitPrice), 0);
  }
}
